// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 28/3/2023
 */

.SearchBar_container__YnQVd {
    display: flex;
    margin: 0.5rem 1.5rem 0.5rem 0.5rem;
}

.SearchBar_searchBox__p2JyU {
    width: 60px;
    height: 40px;
    background-color: #9747FF;
    text-align: center;
    border-radius: 0.5rem 0 0 0.5rem;
}

.SearchBar_icon__hBpLq {
    color: white;
}

.SearchBar_searchText__khWgC {
    width: 100%;
    border: solid 1px #9747FF;
    padding: 0 0 0 10px;
    border-radius: 0 0.5rem 0.5rem 0;
}`, "",{"version":3,"sources":["webpack://./src/Components/Shared/SearchBar.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,aAAa;IACb,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,gCAAgC;AACpC","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 28/3/2023\r\n */\r\n\r\n.container {\r\n    display: flex;\r\n    margin: 0.5rem 1.5rem 0.5rem 0.5rem;\r\n}\r\n\r\n.searchBox {\r\n    width: 60px;\r\n    height: 40px;\r\n    background-color: #9747FF;\r\n    text-align: center;\r\n    border-radius: 0.5rem 0 0 0.5rem;\r\n}\r\n\r\n.icon {\r\n    color: white;\r\n}\r\n\r\n.searchText {\r\n    width: 100%;\r\n    border: solid 1px #9747FF;\r\n    padding: 0 0 0 10px;\r\n    border-radius: 0 0.5rem 0.5rem 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SearchBar_container__YnQVd`,
	"searchBox": `SearchBar_searchBox__p2JyU`,
	"icon": `SearchBar_icon__hBpLq`,
	"searchText": `SearchBar_searchText__khWgC`
};
export default ___CSS_LOADER_EXPORT___;
